import img404 from "../../assets/images/error/404.svg";

const errorContent = {
    backToHome: {
        link: '/',
        btnClass: 'btn btn-icon btn-primary',
        icon: 'arrow-left',
    },
    image: {
        src: img404,
        alt: 'Error 404 Image',
    },
    title: 'Oh ! no',
    description: 'Page Not Found',
    goHomeBtn: {
        link: '/',
        btnClass: 'btn btn-primary',
        text: 'Go To Home',
    },
};

export { errorContent }